/* eslint-disable react/display-name */
import { VoidCallback1 } from '@deqo/foundation';
import { Colors, Select } from './../../../../ui';
import React from 'react';
import styled from 'styled-components';
import { TabularDataDimension } from '../TabularImportModel';

const MappingSelectItemPreview = styled.span`
    margin-left: .5rem;
    color: ${Colors.gray400};
    font-style: italic;
`;

export type MappingSelectorProps = {
    options: TabularDataDimension[],
    value?: TabularDataDimension,
    hasHeaders?: boolean,
    onChange: VoidCallback1<TabularDataDimension>,
};

export const MappingSelector = React.memo<MappingSelectorProps>(({ options, value, hasHeaders, onChange }) => {

    const adapter = {
        key: (d: any) => d.key,
        label: (d: any) => !hasHeaders ? d.keyLabel : d.label,
    };

    return <Select adapter={adapter} items={options} selected={value} onChange={onChange} renderItems={
        (items, selected, onSelect) => items.map((tm, i) =>
            <Select.MenuItem key={tm.key} onClick={onSelect(tm) as any}>
                {!hasHeaders ? tm.keyLabel : tm.label}
                {!hasHeaders && <MappingSelectItemPreview>({tm.label})</MappingSelectItemPreview>}
                {tm.key === selected?.key && <Select.MenuItemCheck />}
            </Select.MenuItem>
        )
    } />;
});
